import { parentTreeItem } from "library/tree/index.mjs"
import { EDIT_TREE, REGIME_IDS } from "library/constants.mjs"

export function isFacilityLike(i) {
    return (
        REGIME_IDS.includes(i.id) ||
        i.data?.type === "facility" ||
        i[parentTreeItem]?.[parentTreeItem]?.id === EDIT_TREE
    )
}
